import template from './sw-product-upselling-assignment.html.twig'
import './sw-product-upselling-assignment.scss'

const { mapGetters, mapState } = Shopware.Component.getComponentHelper()
const { Component, Context } = Shopware
const { Criteria } = Shopware.Data

Component.register('sw-product-upselling-assignment', {
    template,

    inject: ['repositoryFactory'],

    props: {
        upsellingAssignedProducts: {
            type: Array,
            required: true,
        },
        upsellingId: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            isLoadingData: false,
            variantNames: {},
        }
    },

    computed: {
        assetFilter() {
            return Shopware.Filter.getByName('asset')
        },
        isLoadingGrid() {
            return this.isLoadingData;
        },
        assignmentRepository() {
            return this.repositoryFactory.create(
                this.upsellingAssignedProducts.entity,
                this.upsellingAssignedProducts.source
            )
        },
        productRepository() {
            return this.repositoryFactory.create('product')
        },
        searchCriteria() {
            const criteria = new Criteria(1, 25)
            if (this.product) {
                criteria.addFilter(Criteria.not('and', [Criteria.equals('id', this.product.id)]))
            }

            criteria.addFilter(
                Criteria.multi('or', [
                    Criteria.equals('childCount', 0),
                    Criteria.not('and', [Criteria.equals('parentId', null)]),
                ])
            )
            criteria.addAssociation('options.group')
            return criteria
        },
        searchContext() {
            return {
                ...Context.api,
                inheritance: true,
            }
        },
        total() {
            if (!this.upsellingAssignedProducts || !Array.isArray(this.upsellingAssignedProducts)) {
                return 0
            }
            return this.upsellingAssignedProducts.length
        },
        upsellingAssignedProductColumns() {
            return [
                {
                    property: 'product.translated.name',
                    label: this.$tc('sw-product.upselling.columnName'),
                    primary: true,
                    allowResize: true,
                    sortable: false,
                },
                {
                    property: 'product.productNumber',
                    label: this.$tc('sw-product.upselling.columnProductNumber'),
                    allowResize: true,
                    sortable: false,
                },
                {
                    property: 'position',
                    label: this.$tc('sw-product.upselling.inputUpsellingPosition'),
                    allowResize: true,
                    sortable: false,
                },
            ]
        },
        variantProductIds() {
            const variantProductIds = []
            this.upsellingAssignedProducts.forEach((item) => {
                if (!item.product.parentId || item.product.translated.name || item.product.name) {
                    return
                }
                variantProductIds.push(item.product.id)
            })
            return variantProductIds
        },
        variantCriteria() {
            const criteria = new Criteria(1, 25)
            criteria.setIds(this.variantProductIds)
            return criteria
        },
    },

    created() {
        if (this.variantProductIds.length === 0) {
            return
        }
        this.productRepository.search(this.variantCriteria, { ...Context.api, inheritance: true }).then((variants) => {
            const variantNames = {}
            variants.forEach((variant) => {
                variantNames[variant.id] = variant.translated.name
            })
            this.variantNames = variantNames
        })
    },

    methods: {
        onToggleProduct(productId) {
            if (productId === null) {
                return
            }
            this.isLoadingData = true
            const matchedAssignedProduct = this.upsellingAssignedProducts.find((upsellingAssignedProducts) => {
                return upsellingAssignedProducts.productId === productId
            })

            if (matchedAssignedProduct) {
                this.removeItem(matchedAssignedProduct)
                this.isLoadingData = false
            } else {
                const newProduct = this.assignmentRepository.create()
                newProduct.upsellingId = this.upsellingId
                newProduct.productId = productId
                newProduct.position = this.upsellingAssignedProducts.length + 1
                this.upsellingAssignedProducts.add(newProduct)
                const criteria = new Criteria(1, 25)
                criteria.addAssociation('options.group')
                this.productRepository
                    .get(productId, { ...Context.api, inheritance: true }, criteria)
                    .then((product) => {
                        newProduct.product = product
                        this.isLoadingData = false
                    })
            }
        },
        removeItem(item) {
            const oldPosition = item.position
            this.upsellingAssignedProducts.remove(item.id)
            this.upsellingAssignedProducts.forEach((assignedProduct) => {
                if (assignedProduct.position <= oldPosition) {
                    return
                }
                assignedProduct.position -= 1
            })
        },
        isSelected(item) {
            return this.upsellingAssignedProducts.some((p) => p.productId === item.id)
        },
    },
})
